module.exports = __webpack_public_path__ + "static/media/uw.b9c803d4.png";